// src/theme.ts
import { createTheme } from '@material-ui/core/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#CF221A', // 'var(--color-primary)' not work
    },
  }
});


const responsiveTheme = createTheme({
  ...theme,
  typography: {
    fontFamily: 'MSung HK Medium, MSung HK, Noto Serif TC, sans-serif',
    h1: {
      fontSize: 32,
      lineHeight: 1.33,
      fontWeight: 'bold',
      [theme.breakpoints.down('xs')]: {
        fontSize: 24,
      },
    },
		subtitle1: {
			fontSize: 36,
      lineHeight: 1.33,
      [theme.breakpoints.down('xs')]: {
        fontSize: 24,
      },
		},
    subtitle2: { // product
			fontSize: 24,
      lineHeight: 1.33,
      [theme.breakpoints.down('xs')]: {
        fontSize: 12,
      },
		},
		body1: {
			fontSize: 24,
			lineHeight: 1.33,
      [theme.breakpoints.down('xs')]: {
        fontSize: 16,
      },
		},
		body2: {
			fontSize: 16,
			lineHeight: 1.33,
      [theme.breakpoints.down('xs')]: {
        fontSize: 12,
      },
		},
    button: {
      fontSize: 24,
      fontWeight: 400,
      lineHeight: '100%',
      color: 'var(--color-white)',
      '@media (max-width: 900px)': {
        fontSize: 20,
      },
      '@media (max-width: 700px)': {
        fontSize: 16,
      },
      '@media (max-width: 300px)': {
        fontSize: 18,
      },
    },
  },
  overrides: {
    MuiFormLabel: {
      root: {
        fontSize: 24,
			  lineHeight: 1.33,
        marginBottom: 12, 
        color: 'var(--color-tertiary)',
        [theme.breakpoints.down('xs')]: {
          fontSize: 16,
        },
      },
    },
    MuiFormControlLabel: {
      label: {
        fontSize: 24,
			  lineHeight: 1.33,
        [theme.breakpoints.down('xs')]: {
          fontSize: 16,
        },
      },
    },
  },
});

export default responsiveTheme;

// H1=32
// H2=24
// H3=19
// H4=16
// H5=14
// H6=13